import styled, { css } from 'styled-components';

export const SWrapper = styled.div<{ isPlaying: boolean }>`
  position: relative;
  padding: 65px 20px 30px;
  border-radius: 8px;
  background: var(--primary-color);
  user-select: none;

  @media (max-width: 990px) and (max-aspect-ratio: 1/1) {
    padding: 50px 20px 20px;
    border-radius: 8px 8px 0 0;
  }

  @media (max-width: 450px) and (max-aspect-ratio: 1/1) {
    padding: 40px 10px 0;
  }
`;

export const SInner = styled.div<{
  disabled: boolean;
  cellAnimDelay: string;
}>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  width: 100%;
  height: 100%;

  ${({ disabled }) =>
    disabled &&
    css`
      pointer-events: none;
    `}

  ${({ cellAnimDelay }) => cellAnimDelay}
`;
